import { User } from '@/features/auth/types';

// The BFF's user endpoint: the session cookie is HttpOnly, so this is the only
// window into who is signed in. Claims come from Identity Server's profile
// scope; anything missing falls back to the name (the login email).
export interface CurrentUserResponse {
  name: string | null;
  claims: { type: string; value: string }[];
}

const claimValue = (response: CurrentUserResponse, type: string) =>
  response.claims.find(claim => claim.type === type)?.value ?? '';

export const toUser = (response: CurrentUserResponse): User => {
  const userName = response.name ?? claimValue(response, 'name');
  const firstName = claimValue(response, 'given_name');
  const middleName = claimValue(response, 'middle_name');
  const lastName = claimValue(response, 'family_name');

  return {
    fullName:
      [lastName, firstName, middleName].filter(Boolean).join(' ') || userName,
    email: claimValue(response, 'email') || userName,
    firstName,
    lastName,
  };
};
